import React, {
    useEffect,
    useState
} from "react";

import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

import BlogForm from "../../reusables/BlogForm";

import {
    getMethod,
    putMethod
} from "../../../utils/api-service/api-service";

const EditBlogPage = () => {

    const { id } = useParams();

    const navigate = useNavigate();

    const [loading, setLoading] = useState(true);

    const [blog, setBlog] = useState(null);

    useEffect(() => {
        fetchBlog();
    }, []);

    const fetchBlog = async () => {

        const res = await getMethod(
            `/blog/${id}`
        );

        if (res.success) {
            setBlog(res.blog);
        }

        setLoading(false);
    };

    const handleSubmit = async (data) => {

        const formData = new FormData();

        formData.append("title", data.title);
        formData.append("description", data.description);
        formData.append("content", data.content);
        formData.append("author", data.author);
        formData.append("status", data.status);

        if (data.image instanceof File) {
            formData.append(
                "image",
                data.image
            );
        }

        const res = await putMethod(
            `/blog/${id}`,
            formData,
            true
        );

        if (res.success) {

            toast.success(
                data.status === "published"
                    ? "Blog Published"
                    : "Draft Updated"
            );

            navigate("/blogs");
        }
    };

    if (loading) {
        return (
            <div className="text-center py-5">
                Loading...
            </div>
        );
    }

    return (
        <div className="container py-4">

            <h4 className="mb-3">
                Edit Blog
            </h4>

            <BlogForm
                initialData={{
                    title: blog.title || "",
                    description:
                        blog.description || "",
                    content:
                        blog.content || "",
                    author:
                        blog.author || "",
                    image: null,
                    status:
                        blog.status || "draft"
                }}
                onSubmit={handleSubmit}
            />

        </div>
    );
};

export default EditBlogPage;